import styled from '@emotion/styled';
import { ButtonProps, DefaultButtonCss } from '@components/atoms/Inputs/Button/Primary';

const DefaultButton = styled.button`
  ${DefaultButtonCss};
  background: unset;
  width: 326px;
  height: 48px;
  border-width: 1px;
  border-style: solid;
  border-radius: 48px;
  font-size: 18px;
  border-color: #555555;
  color: #555555;

  :hover {
    background-color: #efefef;
  }

  :active {
    background-color: #555555;
    color: #ffffff;
  }

  :disabled {
    cursor: not-allowed;
    border-color: #999999;
    color: #999999;
  }
  ${(props: ButtonProps) => props.styles};
`;

export default DefaultButton;
